import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/Industries/SMEs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/JsonLd.tsx");
